/* global File, FormData */
import { put, select, call, take, race } from 'redux-saga/effects';
import fetch from 'isomorphic-fetch';
import { siteRoot } from '../../config';
import actionKey from '../utils/action-key';
import { authErrorAction, updateTokenAction, LOGOUT } from '../redux/auth';

export function* somethingWentWrong(type, res, rest) {
    let result;
    try {
        result = yield res.json();
    } catch (e) {
        // ignore
    }
    const error = {
        type: actionKey.failure(type),
        error: result && result.error ? result.error : 'Something went wrong',
        status: res.status,
        ...rest,
    };
    yield put(error);
    return error;
}

/**
 * sometimes fetch fail sync so this is guard
 * to prevent to everything fall apart
 */
const fetchWithGuard = async (url, options) => {
    let result;
    try {
        result = await fetch(url, options);
    } catch (e) {
        return {
            error: e.message || 'Something went wrong',
        };
    }

    return result;
};

export default function* request({
    type, // action name (ex. LOGIN, FETCH_USER)
    url,
    options = {},
    responseType = 'json',
    cancelActions = [],
    ...rest
}) {
    yield put({
        url,
        options,
        responseType,
        type: actionKey.init(type),
        ...rest,
    });
    const now = Date.now();
    const { auth } = yield select();
    const cacheBust = `${url.indexOf('?') === -1 ? '?' : '&'}_${now}`;
    const fullUrl = `${siteRoot}${url}${cacheBust}`;
    const headers = {
        AuthToken: auth.token ? auth.token : null,
    };
    let body;
    const upload = options.body && Object.keys(options.body).find((key) => {
        const field = options.body[key];
        return field instanceof File;
    });
    if (upload) {
        body = new FormData();
        Object.keys(options.body).forEach((name) => {
            if (options.body[name] == null) {
                return;
            }
            body.append(name, options.body[name]);
        });
    } else if (options.body) {
        body = JSON.stringify(options.body);
    }
    if (!upload) {
        headers.accept = 'application/json';
        headers['Content-Type'] = 'application/json';
    }
    const { res, cancel } = yield race({
        res: call(fetchWithGuard, fullUrl, {
            ...options,
            body,
            headers: {
                ...headers,
                ...(options.headers || {}),
            },
        }),
        cancel: take([LOGOUT, ...cancelActions]),
    });

    if (cancel) {
        return null;
    }

    if (res.status === 402 || res.status === 401) {
        yield call(somethingWentWrong, type, res, rest);
        return yield put(authErrorAction({
            ...rest,
            error: res.status === 401 ? 'Authentication error' : 'Expired',
            status: res.status,
        }));
    }

    if (res.status !== 200) {
        // TODO report this error to the some third party service
        return yield call(somethingWentWrong, type, res, rest);
    }

    let payload;
    try {
        payload = yield res[responseType]();
    } catch (e) {
        return yield call(somethingWentWrong, type, res, rest);
    }
    const token = res.headers.get('AuthToken');
    if (token) {
        yield put(updateTokenAction(res.headers.get('AuthToken')));
    }

    yield put({
        payload,
        type: actionKey.success(type),
        ...rest,
    });

    return {
        ...rest,
        payload,
        token,
        status: res.status,
        type: actionKey.success(type),
    };
}



// WEBPACK FOOTER //
// ./src/client/api-utils/request.js